<div class="d-flex wrapper" >
    <div class="logo">
        <img
            [src]="
            comment?.messages?.profilePictureUrl
                    ? comment?.messages?.profilePictureUrl
                    : 'assets/common/images/default-profile-picture.png'
            "
            class="mr-3 rounded-circle w-100"
        />
    </div>
    <div class="w-80" *ngIf="comment?.messages?.entityObjectTypeCode!=='MESSAGE'">
        <div class="w-100 text-wrapper p-3">
            <div class="d-flex justify-content-between">
                <h5 class="senderN">{{comment?.messages?.senderName}}</h5>
                <div>
              <p style="font-size: 12px; color: #999999;white-space: nowrap;margin: 0;">{{comment?.messages?.receiveDate?.toString() | date: 'MMM d y' }}</p>
              <p style="font-size: 12px; color: #999999;white-space: nowrap;">{{comment?.messages?.receiveDate?.toString() | date: 'h:mm a' }}</p>
            </div>
            </div>
            <p
            #content
            style="word-wrap: break-word;"
            class="bodyP"
          >
            {{ displayedContent }}
            <span
              class="see-more"
              *ngIf="isLongContent"
              (click)="toggleExpand()"
            >
              {{ isExpanded ? 'See Less' : 'See More' }}
            </span>
          </p>
          
          
          
        </div>
    </div>
    <div class="w-80" *ngIf="comment?.messages?.entityObjectTypeCode=='MESSAGE'">
        <div class="w-100 text-wrapper p-3">


          <div class="d-flex justify-content-between">
          <div>
            <small>From : {{comment?.messages?.senderName}}</small>
            <br/>
            <small>To : {{comment?.messages?.toName}}</small>
          </div>
            <div>
          <p style="font-size: 12px; color: #999999;white-space: nowrap;margin: 0;">{{comment?.messages?.receiveDate?.toString() | date: 'MMM d y' }}</p>
          <p style="font-size: 12px; color: #999999;white-space: nowrap;">{{comment?.messages?.receiveDate?.toString() | date: 'h:mm a' }}</p>
        </div>
        </div>
  
            <br *ngIf="comment?.messages?.ccUsers"/>
            <small *ngIf="comment?.messages?.ccUsers">CC : {{comment?.messages?.ccUsers}}</small>
             <br />
             <small *ngIf="comment?.messages?.bccUsers">BCC : {{comment?.messages?.bccUsers}}</small>

            <h6 class="subject-title mt-1 ,b-0">Subject : {{comment?.messages?.subject}}</h6>
            <!-- <hr/> -->
            <p class="message-body">
              <span [innerHTML]="getFormattedContent()"></span>
              <span class="see-more" *ngIf="comment?.messages?.bodyFormat.length > charLimit" (click)="toggleExpand()">
                {{ isExpanded ? ' See Less' : ' See More' }}
              </span>
            </p>
            
        </div>
    </div>
</div>
